export default "__VITE_ASSET__kntIwhSZ__"